import ConfirmDialogWrapper from '@/components/ConfirmDialogWrapper.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import { isString, isObject } from 'lodash';

const getSlot = (instance, el, data, defaultData) => {
  const resolvedData = data(instance);

  // eslint-disable-next-line no-underscore-dangle
  if (isObject(el) && el.render) {
    return instance.$createElement(el,
      {
        ...defaultData,
        ...resolvedData,
      });
  }

  if (isString(el) && (!resolvedData || isString(resolvedData))) {
    return instance.$createElement(el, resolvedData);
  }

  return null;
};

export default {
  install(Vue) {
    // eslint-disable-next-line func-names
    Vue.prototype.$norticConfirm = function ({
      el = ConfirmDialog,
      data = () => ({}),
      wrapperClickEvent = undefined,
      transparentWrapper = false,
    } = {}) {
      let instance;

      return new Promise((resolve, reject) => {
        if (this.$root.$el.querySelectorAll('.confirm-dialog-wrapper').length === 0) {
          const DialogComponent = Vue.extend(ConfirmDialogWrapper);

          instance = new DialogComponent({
            propsData: {
              wrapperClickEvent,
              transparentWrapper,
            },
          });

          instance.$on('resolve', (e) => {
            resolve(e);
          });
          instance.$on('reject', (e) => {
            reject(e);
          });

          const defaultData = {
            props: undefined,
            on: {
              confirm: instance.confirm,
              cancel: instance.cancel,
            },
          };

          const slot = getSlot(instance, el, data, defaultData);

          if (slot) {
            instance.$slots.default = [slot];

            instance.$mount();

            instance.$createElement();

            this.$el.appendChild(instance.$el);
          } else {
            reject(new Error('The component could not be created'));
          }
        } else {
          reject(new Error('A modal is aldready in progress'));
        }
      }).finally(() => {
        if (instance) {
          instance.$destroy();
        }
      });
    };
  },
};
